module.exports = __webpack_public_path__ + "img/icon-warning-polarlow-red.11979e74.svg";